//#region
import { useState, useEffect } from 'react';
//material
import { Grid, FormControl, InputLabel, Select as MSelect, MenuItem, Checkbox, ListItemText } from '@mui/material';
// component
import Controls from '../../controls/Controls';
import { useForm, Form } from "../../useForm";
import { getUserType } from '../../../config/services/usertype';
//#endregion

const initialFValues = {
  _id: 0,
  roleName: ''
}

export default function RolePopup(props) {
  const { addOrEdit, recordForEdit, setOpenPopup } = props
  const [userTypeList, setUserTypeList] = useState([]);
  const [userTypeAccess, setUserTypeAccess] = useState(null);

  const fetchUserTypeList = () => {
    let params = { pageNo: 0 }
    getUserType(params).then((res) => {
      setUserTypeList([...res?.result]);
    });
  }

  useEffect(() => {
    fetchUserTypeList();
  }, []);

  const setUserTypeValueInital = (value) => {
    if (value && value[0]) {
      setUserTypeAccess(value[0]._id)
    }
  }

  useEffect(() => {
    setUserTypeValueInital(recordForEdit?.userType);
  }, [recordForEdit])

  const validate = (fieldValues = values) => {
    let temp = { ...errors }
    if ('roleName' in fieldValues) {
      temp.roleName = fieldValues.roleName ? "" : "This field is required."
    }
    
    setErrors({
      ...temp
    })
      
    if (fieldValues === values)
      return Object.values(temp).every(x => x === "")
  }

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    resetForm
  } = useForm(initialFValues, true, validate);

  const handleSubmit = e => {
    e.preventDefault()
    if (validate()) {
      values.userType = [userTypeAccess];
      addOrEdit(values, resetForm);
    }
  }
  
  useEffect(() => {
    if (recordForEdit != null)
      setValues({
        ...recordForEdit
      })
  }, [recordForEdit, setValues])


  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={8}>
          <Controls.Input
            name="roleName"
            label="Role Name"
            value={values.roleName}
            onChange={handleInputChange}
            error={errors.roleName}
          />
        </Grid>
        <Grid item xs={8}>
          <FormControl variant="outlined" sx={{ m: 1, width: 120 }}>
            <InputLabel htmlFor="outlined-age-native-simple">User Type</InputLabel>
            <MSelect
              value={userTypeAccess || ""}
              label="User Type"
              onChange={(e) => setUserTypeAccess(e.target.value)}
            >
              {
                userTypeList?.map((data) => (
                  <MenuItem key={data?._id} value={data?._id}>
                    <ListItemText primary={data?.userTypeName} />
                  </MenuItem>
                ))
              }
            </MSelect>
          </FormControl>
        </Grid>
        
        <Grid item xs={8}>
          <div>
            <Controls.Button
              type="submit"
              text="submit"
            />
            <Controls.Button
              color="secondary"
              text="Cancel"
              onClick={e => setOpenPopup(false)}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  )
}